import type { ReactNode } from "react";
import { Link } from "react-router";
import type { RichText } from "../content/types";

const LINK_CLASS =
  "text-ds-brand-700 hover:text-ds-brand-800 focus-visible:outline-ds-focus cursor-pointer underline underline-offset-4 focus-visible:outline-2";

// Uma passada só: negrito ou link, o que vier primeiro.
const TOKEN = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;

type LegalRichTextProps = {
  text: RichText;
};

/** Renderiza o `RichText` dos documentos: `**negrito**` e `[rótulo](href)`. */
export const LegalRichText = ({ text }: LegalRichTextProps) => {
  const parts: ReactNode[] = [];
  let cursor = 0;

  for (const match of text.matchAll(TOKEN)) {
    const start = match.index ?? 0;
    if (start > cursor) parts.push(text.slice(cursor, start));

    const [, bold, label, href] = match;
    if (bold) {
      parts.push(
        <strong key={start} className="text-ds-ink-900 font-semibold">
          {bold}
        </strong>
      );
    } else if (href.startsWith("/")) {
      parts.push(
        <Link key={start} to={href} className={LINK_CLASS}>
          {label}
        </Link>
      );
    } else {
      const isExternal = href.startsWith("http");
      parts.push(
        <a
          key={start}
          href={href}
          className={LINK_CLASS}
          {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
        >
          {label}
          {isExternal && <span className="sr-only"> (abre em nova aba)</span>}
        </a>
      );
    }
    cursor = start + match[0].length;
  }
  if (cursor < text.length) parts.push(text.slice(cursor));

  return <>{parts}</>;
};
